
.legal-disclaimer {
    display: flex;
    flex-direction: column;
    font-family: var(--ux-font, "Frutiger-Web", sans-serif);
    background: white;
    padding: 30px;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    ux-copy {
        font-size: var(--ux-font-size-normal);
    }
    &__header {
        margin-bottom: 8px;
    }

    &__content {
        margin-bottom: 30px;
    }

    &__checkbox {
        margin-bottom: 30px;
        input {
            margin-right: 8px;
            accent-color: #bbd03a;
        }
    }

    &__button {
        align-self: center;
    }
}
